import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-toast-notification',
    imports: [CommonModule],
    templateUrl: './toast-notification.component.html',
    styleUrl: './toast-notification.component.scss'
})
export class ToastNotificationComponent {
  @Input() notification: any;
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  @Input() changeColor: boolean = false

  ngOnInit(): void {
    setTimeout(() => {
      this.close.emit()
    }, 3000);
  }




}
